export { default as InvoiceItemsViewTable } from './InvoiceItemsViewTable';
